import { render, staticRenderFns } from "./jgProcessSel.vue?vue&type=template&id=c2033108&scoped=true&"
import script from "./jgProcessSel.vue?vue&type=script&lang=js&"
export * from "./jgProcessSel.vue?vue&type=script&lang=js&"
import style0 from "./jgProcessSel.vue?vue&type=style&index=0&id=c2033108&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2033108",
  null
  
)

export default component.exports